import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { btlApplicationsApi } from '@api/btlApplications/btlApplicationsApi';
export const useBtlApplications = (): UseQueryResult<any> =>
  useQuery(['btl-applications'], () => btlApplicationsApi.getAll() || null);
